import { useCallback, useContext, useMemo } from 'react';
import { Accordion, AccordionContext, Button, useAccordionButton } from 'react-bootstrap';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import SortableItem from './SortableItem';
import Icon from "../Icon";

const CustomToggle = ({ children, eventKey }) => {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey);

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <div className="row m-0 align-items-center w-100">
            <div className="col-auto">
                <button type="button"
                    id={eventKey}
                    onClick={decoratedOnClick}
                    className="btn btn-outline-primary border-0 p-0"
                >
                    <Icon className="d-block" icon={isCurrentEventKey ? "RemoveCircle" : "AddCircleOutline"} />
                </button>

            </div>
            {children}
        </div>
    );
};

const SortableAccordion = ({
    data,
    attr,
    drag,
    callbacks
}) => {

    const callbackButtons = useCallback((dataElement, index, value) => callbacks ? Object.values(callbacks).map(({ hiddenIndices, variant, icon, callback, }, i) => {
        if (hiddenIndices && hiddenIndices.includes(index)) {
            return null;
        }

        return (
            <Button
                variant={variant}
                className='col-auto ms-1 border-0 p-0'
                onClick={(event) => callback(event, dataElement, value)}
                key={i}
            >
                <Icon icon={icon} />
            </Button>
        );
    }) : null, [callbacks]);

    const renderAccordionItem = useCallback((index, entry) =>
        <CustomToggle eventKey={index}>
            <label className="col-auto">{entry.displayId}</label>
            <div className="col"></div>
            {callbackButtons(entry._id, index, entry[attr])}
        </CustomToggle>
        , [attr, callbackButtons]);

    const renderAccordion = useMemo(() => <Accordion>
        {data.map((entry, index) =>
            <Accordion.Item eventKey={index} key={index}>
                {drag ? <SortableItem
                    index={index}
                    styles={{
                        default: `flex-grow-1 d-flex flex-row p-2 align-items-center`,
                        dragging: `flex-grow-1 d-flex flex-row p-2 align-items-center`,
                    }}
                    {...drag}
                >
                    {renderAccordionItem(index, entry)}
                </SortableItem>
                    :
                    <div className="py-2 ps-2">{renderAccordionItem(index, entry)}</div>
                }
                <Accordion.Body className="pt-0">
                    {entry[attr]}
                </Accordion.Body>
            </Accordion.Item>
        )}
    </Accordion>, [attr, data, drag, renderAccordionItem])

    if (drag) {
        return <DndProvider backend={HTML5Backend}>
            {renderAccordion}
        </DndProvider>
    }

    return renderAccordion;
};

export default SortableAccordion;